import { useMutation } from "@tanstack/react-query"
import { Form, Input } from "antd"
import { Button } from "components"
import { mixPanelEvent } from "components/new-stuff/mix-panel/MixPanel"
import NewModalWrapper from "components/new-stuff/ui/modals/NewModalWrapper"
import React, { useState } from "react"
import { paymentSchedulesService } from "services/paymentSchedulesService"
import { useAppNotificationStore, useAuthStore } from "stores"
import getIdFromKey from "utils/getIdFromKey"
import { onQueryError } from "utils/utils"
type Props = {
  onClose: () => void
  invalidateQueries: () => void
  open: boolean
  paymentId: string
  x: string
  currency?: string
}

export const RetryPayment = ({
  onClose,
  open,
  paymentId,
  x,
  invalidateQueries,
  currency,
}: Props) => {
  const { toast } = useAppNotificationStore()
  const { user } = useAuthStore()
  const [comment, setComment] = useState("")
  const { isLoading: isSubmittingRetry, mutate: submitRetry } = useMutation({
    mutationFn: async () => {
      const data = await paymentSchedulesService.retryFailedPayment(
        paymentId,
        currency
      )

      return data
    },
    onSuccess: (data) => {
      onClose()
      data?.message && toast.success(data.message)
      mixPanelEvent("pay-schedule-payout-retry-success")
      invalidateQueries()
    },
    onError: (e) => {
      onClose()
      onQueryError(e)
      mixPanelEvent("pay-schedule-payout-retry-failed")
    },
  })

  const { isLoading: isSubmittingRetryAll, mutate: submitRetryAll } =
    useMutation({
      mutationFn: async () => {
        const data = await paymentSchedulesService.retryFailedPayments(
          paymentId,
          currency
        )

        return data
      },
      onSuccess: (data) => {
        onClose()
        data?.message && toast.success(data.message)
        mixPanelEvent("pay-schedule-payout-retry-success")
        invalidateQueries()
      },
      onError: (e) => {
        onQueryError(e)
        onClose()
        mixPanelEvent("pay-schedule-payout-retry-failed")
      },
    })
  return (
    <NewModalWrapper
      open={open}
      title={
        paymentId == getIdFromKey(x || "") ? "Retry Payments" : "Retry Payment"
      }
      className="w-[750px]"
      onClose={onClose}
    >
      <div className="px-5 py-3">
        <p className=" text-neutral300 mb-5 text-sm">
          {paymentId == getIdFromKey(x || "")
            ? "Retry all failed payments"
            : "Retry this failed payment"}
        </p>
      </div>
      <div className="border py-5 px-6 flex gap-4 justify-end  ">
        <Button
          color="secondary"
          onClick={onClose}
        >
          Cancel
        </Button>

        <Button
          color="primary"
          submitting={isSubmittingRetry || isSubmittingRetryAll}
          onClick={() => {
            mixPanelEvent("pay-schedule-payout-retry-init")
            {
              paymentId == getIdFromKey(x || "")
                ? submitRetryAll()
                : submitRetry()
            }
          }}
        >
          Retry
        </Button>
      </div>
    </NewModalWrapper>
  )
}

export default RetryPayment
